import { motion, AnimatePresence } from "framer-motion";
import React, { useEffect, useState } from "react";
import { images } from "../../constants";

const headTextTicks = [
  "Connect with people around you effortlessly",
  "Filter by interests for meaningful conversations",
  "Start chatting instantly, no small talk required",
];

const imageSrcs = [
  images.loginPortrait,
  images.mapPortrait,
  images.notifPortrait,
];

const Hero = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prev) => (prev + 1) % imageSrcs.length);
    }, 4000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="app__home-hero" id="home">
      <div className="app__home-hero-presentation">
        <motion.div
          className="app__home-hero-text"
          initial="hidden"
          animate="visible"
          variants={{
            hidden: {},
            visible: {
              transition: {
                staggerChildren: 0.4,
              },
            },
          }}
        >
          <motion.h1
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, ease: "easeOut" }}
            variants={{
              hidden: { opacity: 0, y: 50 },
              visible: { opacity: 1, y: 0 },
            }}
          >
            Open For Conversation
          </motion.h1>
          <motion.div
            className="app__home-hero-list-container"
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, ease: "easeOut" }}
            variants={{
              hidden: { opacity: 0, y: 50 },
              visible: { opacity: 1, y: 0 },
            }}
          >
            {headTextTicks.map((value, index) => (
              <motion.div
                className="app__home-hero-list-item"
                key={index}
                whileInView={{ x: [100, 0], opacity: [0, 1] }}
                transition={{ duration: 0.5, delay: index * 0.2 }}
              >
                <img src={images.tickLight} alt="tick" height="15" />
                <p>{value}</p>
              </motion.div>
            ))}
          </motion.div>
          <motion.div
            className="app__home-hero-button"
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, ease: "easeOut" }}
            variants={{
              hidden: { opacity: 0, y: 50 },
              visible: { opacity: 1, y: 0 },
            }}
            style={{ zIndex: 5 }}
          >
            <a href="#subscribe">Join our Newsletter</a>
          </motion.div>
        </motion.div>
        <div
          className="app__home-hero-img"
          style={{
            position: "relative",
            overflow: "hidden",
          }}
        >
          <AnimatePresence mode="wait">
            <motion.img
              key={currentImageIndex}
              src={imageSrcs[currentImageIndex]}
              alt="iPhone App Screen"
              initial={{ x: 100, opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              exit={{ x: -100, opacity: 0 }}
              transition={{ duration: 0.5, ease: "easeInOut" }}
              style={{
                position: "absolute",
                width: "100%",
                height: "100%",
                objectFit: "contain",
                objectPosition: "center",
                zIndex: 10,
              }}
            />
          </AnimatePresence>
        </div>
      </div>
      <div
        style={{
          height: "100%",
          width: "100%",
          position: "absolute",
          display: "flex",
          justifyContent: "center",
          alignItems: "flex-end",
        }}
      >
        <img
          alt="background"
          src={images.background}
          style={{
            height: "40vh",
            width: "100%",
            zIndex: 1,
          }}
        />
      </div>
    </div>
  );
};

export default Hero;
